module.exports = __webpack_public_path__ + "img/set-password-link-outdated.5ecc1ec2.jpg";